import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    IHealthcareProfessional,
    IHealthcareProfessionalPayload,
} from '../../entities/healthcareProfessional/HealthcareProfessional.ts';
import { IPatient } from '../../entities/Patients/Patient.ts';

// /api/HealthcareProfessionals/{healthcareProfessionalID}/Patients

export class HealthcareProfessionalsApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HealthcareProfessionals`;
    public static apiUrls: {
        getPatients: string;
        getHealthcareProfessionals: string;
        postHealthcareProfessional: string;
        getHealthcareProfessionalById: string;
        deleteHealthcareProfessionalyId: string;
        getHealthcareProfessionalNew: string;
        putHealthcareProfessionalById: string;
        getCurrentPatients: string;
    } = {
        getPatients: `${HealthcareProfessionalsApi.baseApiUrl}`,
        getHealthcareProfessionals: `${HealthcareProfessionalsApi.baseApiUrl}`,
        postHealthcareProfessional: `${HealthcareProfessionalsApi.baseApiUrl}`,
        getHealthcareProfessionalById: `${HealthcareProfessionalsApi.baseApiUrl}/:id`,
        getHealthcareProfessionalNew: `${HealthcareProfessionalsApi.baseApiUrl}/New`,
        deleteHealthcareProfessionalyId: `${HealthcareProfessionalsApi.baseApiUrl}/:id`,
        putHealthcareProfessionalById: `${HealthcareProfessionalsApi.baseApiUrl}/:id`,
        getCurrentPatients: `${HealthcareProfessionalsApi.baseApiUrl}/Current/Patients`,
    };

    public static async getPatients(healthcareProfessionalID: string, facilityId?: number): Promise<IPatient[]> {
        const query = facilityId ? `?facilityId=${facilityId}` : '';
        return this.sendApiRequest<IPatient[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getPatients}/${healthcareProfessionalID}/Patients${query}`,
        });
    }

    public static async getHealthcareProfessionals(): Promise<[IHealthcareProfessional] | undefined> {
        return this.sendApiRequest<[IHealthcareProfessional]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getHealthcareProfessionals,
        });
    }

    public static async getByFacilityId(facilityId: number): Promise<IHealthcareProfessional[]> {
        return this.sendApiRequest<IHealthcareProfessional[]>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/by-facility/${facilityId}`,
        });
    }

    public static async getHealthcareProfessionalNew(): Promise<IHealthcareProfessional | undefined> {
        return this.sendApiRequest<IHealthcareProfessional>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getHealthcareProfessionalNew,
        });
    }

    public static async postHealthcareProfessional(
        data: IHealthcareProfessionalPayload,
    ): Promise<number | undefined> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postHealthcareProfessional,
            data: data,
            suppressGlobalErrorHandling: true
        });
    }

    public static async getHealthcareProfessionalById(id: string): Promise<IHealthcareProfessional | undefined> {
        return this.sendApiRequest<IHealthcareProfessional>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getHealthcareProfessionalById,
            data: undefined,
            id: id,
        });
    }

    public static async deleteHealthcareProfessionalyId(id: string): Promise<IHealthcareProfessional | undefined> {
        return this.sendApiRequest<IHealthcareProfessional>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteHealthcareProfessionalyId,
            data: undefined,
            id: id,
        });
    }

    public static async putHealthcareProfessionalById(
        data: IHealthcareProfessionalPayload,
        id: string,
    ): Promise<IHealthcareProfessional> {
        return this.sendApiRequest<IHealthcareProfessional>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putHealthcareProfessionalById,
            data: data,
            id: id,
            suppressGlobalErrorHandling: true
        });
    }

    public static async getCurrentPatients(): Promise<[IPatient] | undefined> {
        return this.sendApiRequest<[IPatient]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getCurrentPatients,
        });
    }
}
